// App.js
import React, { useEffect } from "react";
import { useLocation, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Login from "./pages/SHARED/Login";
import GuestRequestSample from "./pages/SHARED/GuestRequestSample";
import Register from "./pages/SHARED/Register";
import FirstTimeRegister from "./pages/SHARED/FirstTimeRegister";
import AuthGuard from "./pages/SHARED/Utilities/AuthGuard";
import RequireSuperUser from "./pages/SHARED/Utilities/RequireSuperUser";

import AdminHome from "./pages/Internal User/Admin User/Home";
import VermostProbateBondRequestForm from "./pages/SHARED/Bond Creation/ProbateBond";
import VermostGuardianshipBondRequestForm from "./pages/SHARED/Bond Creation/GuardianshipBond";
import VermostVABondRequestForm from "./pages/SHARED/Bond Creation/VABond";
import VermostTrusteeBondRequestForm from "./pages/SHARED/Bond Creation/TrusteeBond";
import ProfessionalGuardianList from "./pages/Internal User/Shared Management Pages/Professional Guardian Management/ProfessionalGuardianList";
import ProfessionalGuardianView from "./pages/Internal User/Shared Management Pages/Professional Guardian Management/ProfessionalGuardianView";
import CarrierList from "./pages/Internal User/Shared Management Pages/Carrier Management/CarrierList";
import LawFirmList from "./pages/Internal User/Shared Management Pages/Law Firm Management/LawFirmList";
import UserList from "./pages/Internal User/Shared Management Pages/Internal User Management/UserList";
import CarrierProfile from "./pages/Internal User/Shared Management Pages/Carrier Management/CarrierProfile";
import PremiumManager from "./pages/Internal User/Shared Management Pages/Other Management Pages/PremiumManager";
import AdminAccountManagement from "./pages/Internal User/Admin User/AccountManagement";
import ApproveBondsPage from "./pages/ApproveBondsPage";
import BondArchives from "./pages/BondArchives";
import VermostProbateBondRetrieveForm from "./pages/SHARED/Bond Retrieval/ProbateBondRetrieve";
import CarrierTeamMemberDashboard from "./pages/CarrierTeamMemberDashboard";
import ApproveBondsTeamMemberPage from "./pages/ApproveBondsTeamMember";
import PremiumCalculator from "./pages/SHARED/PremiumCalculator";
import ProfessionalGuardianRegister from "./pages/Professional Guardian User/ProfressionalUserGuardianRegister";
import CreateInternalUser from "./pages/Internal User/Shared Management Pages/Internal User Management/NewInternalUser";
import EditInternalUser from "./pages/Internal User/Shared Management Pages/Internal User Management/EditInternalUser";
import ViewEnhancementRequests from "./pages/Internal User/Admin User/EnhancementRequests";

import BondNumberTable from "./pages/Internal User/Shared Management Pages/Other Management Pages/BondNumber";
import LawSchoolList from "./pages/Internal User/Shared Management Pages/Other Management Pages/LawSchools";
import StateList from "./pages/Internal User/Shared Management Pages/Other Management Pages/StateList";
import BondTypeList from "./pages/Internal User/Shared Management Pages/Other Management Pages/BondTypes";
import StateDetails from "./pages/Internal User/Shared Management Pages/Other Management Pages/StateDetails";
import CreateLawFirm from "./pages/Internal User/Shared Management Pages/Law Firm Management/CreateLawFirm";
import LawFirmDetail from "./pages/Internal User/Shared Management Pages/Law Firm Management/LawFirmDetails";
import LegalServiceProfessionalForm from "./pages/Internal User/Shared Management Pages/Law Firm Management/AddLawFirmUser";
import SimpleUserAccountManagement from "./pages/Internal User/Internal User/AccountManagement";
import SimpleUserHome from "./pages/Internal User/Internal User/Home";
import EditProfessionalDetailsForm from "./pages/Internal User/Shared Management Pages/Law Firm Management/EditLawFirmUser";
import ProfessionalGuardianHome from "./pages/Professional Guardian User/Home";
import ObligeeList from "./pages/Internal User/Shared Management Pages/Other Management Pages/ObligeeList";

import VermostOutsiderStartBondRequest from "./pages/SHARED/Bond Creation/StartRequest";
import VermostBlanketBondRequestForm from "./pages/SHARED/Bond Creation/BlanketBond";

import TeamMemberRegister from "./pages/Carrier Team Member User/TeamMemberRegister";
import InternalUserRegister from "./pages/Internal User/InternalUserRegister";
import CreateLocations from "./pages/Internal User/Shared Management Pages/Law Firm Management/CreateLocation";
import LawFirmLocationDetail from "./pages/Internal User/Shared Management Pages/Law Firm Management/LawFirmLocationDetail";
import UserProfileUpdate from "./pages/SHARED/UserProfileUpdate";
import ProfessionalGuardianLimits from "./pages/Internal User/Shared Management Pages/Professional Guardian Management/ProfessionalGuardianLimits";
import LawFirmUserRegister from "./pages/Law Firm User/LawFirmUserRegister";
import LawFirmUserHome from "./pages/Law Firm User/LawFirmUserHome";
import LawFirmUserAdminHome from "./pages/Law Firm User/LawFirmUserAdminHome";
import LawFirmAccessRequests from "./pages/Law Firm User/LawFirmAccessRequests";
import VermostGuardianshipBondRetrieveForm from "./pages/SHARED/Bond Retrieval/GuardianshipBondRetrieve";
import VermostVABondRetrieveForm from "./pages/SHARED/Bond Retrieval/VABondRetrieve";
import VermostTrusteeBondRetrieveForm from "./pages/SHARED/Bond Retrieval/TrusteeBondRetrieve";
import VermostBlanketBondRetrieveForm from "./pages/SHARED/Bond Retrieval/BlanketBondRetrieve";
import CreateProfessionalGuardian from "./pages/Internal User/Shared Management Pages/Professional Guardian Management/ProfessionalGuardianCreate";
import LawfirmApproveBondsPage from "./pages/Law Firm User/LawFirmApproveBonds";
import LawfirmCancelBondsPage from "./pages/Law Firm User/LawFirmCancelBonds";
import LawfirmEndorseBondsPage from "./pages/Law Firm User/LawFirmEndorseBonds";
import ProfessionalGuardianViewBonds from "./pages/Professional Guardian User/ProfessionalGuardianViewBonds";

import ProbateRider from "./pages/Internal User/Admin User/ProbateRider";
import GuardianshipRider from "./pages/Internal User/Admin User/GuardianshipRider";
import TrusteeRider from "./pages/Internal User/Admin User/TrusteeRider";
import VABondRider from "./pages/Internal User/Admin User/VABondRider";

import Analytics from "./pages/Internal User/Admin User/Analytics";
import LawFirmUserLimits from "./pages/Internal User/Shared Management Pages/Law Firm Management/LawFirmUserLimits";
import AdminDataManagement from "./pages/Internal User/Admin User/DataManagement";
import AdminSystemManagement from "./pages/Internal User/Admin User/SystemManagement";
import SimpleUserDataManagement from "./pages/Internal User/Internal User/DataManagement";
import SimpleUserSystemManagement from "./pages/Internal User/Internal User/SystemManagement";
import EnhancementCenter from "./pages/SHARED/EnhancementCenter";
import Announcement from "./pages/Internal User/Shared Management Pages/Other Management Pages/Announcement";
import ManuallySignedIndemnities from "./pages/Internal User/Admin User/ManuallySignedIndemnities";

import VermostOutsiderStartBondRequestHistoric from "./pages/SHARED/Bond Creation Historic/StartRequest";
import ProbateBondCreateHistoric from "./pages/SHARED/Bond Creation Historic/ProbateBondCreateHistoric";
import GuardianshipBondCreateHistoric from "./pages/SHARED/Bond Creation Historic/GuardianshipBondCreateHistoric";
import TrusteeBondCreateHistoric from "./pages/SHARED/Bond Creation Historic/TrusteeBondCreateHistoric";
import BlanketBondCreateHistoric from "./pages/SHARED/Bond Creation Historic/BlanketBondCreateHistoric";
import VABondCreateHistoric from "./pages/SHARED/Bond Creation Historic/VABondCreateHistoric";
import PgContactHome from "./pages/Professional Guardian Contact User/Home";
import PgContactRegister from "./pages/Professional Guardian Contact User/PgContactRegister";
import SupportRequestsLog from "./pages/admin/SupportRequestsLog";

// Paralegal Management
import ParalegalList from "./pages/Internal User/Shared Management Pages/Paralegal Management/ParalegalList";
import NewParalegal from "./pages/Internal User/Shared Management Pages/Paralegal Management/NewParalegal";
import ParalegalDetail from "./pages/Internal User/Shared Management Pages/Paralegal Management/ParalegalDetail";
import LawFirmUserList from "./pages/Internal User/Shared Management Pages/Law Firm Management/LawFirmUserList";
import DuplicateAccountsMergePage from "./pages/Internal User/Shared Management Pages/Account Duplicates/DuplicateAccountsMergePage";

import { Box } from "@mui/material";
import Footer from "./globals/components/Footer";
import { forceIamReplay } from "./globals/utils/iamObservability";

function App() {
  const { pathname } = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  // Full Session Replay for registration flows — record the whole session from
  // page entry (not just from the first API call), so silent client-side
  // failures with no backend trace are captured. Covers the static registration
  // pages and the tokenized invite-registration routes. Login replay is triggered
  // on first interaction via the API layer (avoids recording every anonymous "/").
  useEffect(() => {
    const IAM_REPLAY_PREFIXES = [
      "/register", "/first-time-register",
      "/team-member-register/", "/internal-user-register/",
      "/lawfirm-user-register/", "/professional-guardian-register/",
      "/pg-contact-register/",
    ];
    if (IAM_REPLAY_PREFIXES.some((p) => pathname === p || pathname.startsWith(p))) {
      forceIamReplay();
    }
  }, [pathname]);

  // Define routes where footer should be hidden
  const hideFooterRoutes = [
    "/",
    "/register",
    "/first-time-register",
    "/team-member-register",
    "/internal-user-register",
    "/lawfirm-user-register",
    "/professional-guardian-register",
    "/pg-contact-register",
    "/guest-request",
    "/vermost-probate-bond-request-guest",
    "/vermost-guardianship-bond-request-guest",
    "/vermost-trustee-bond-request-guest",
    "/vermost-va-bond-request-guest",
    "/vermost-blanket-bond-request-guest"
  ];

  // Check if current path should hide footer (including dynamic routes with tokens)
  const shouldShowFooter = !hideFooterRoutes.some(route =>
    pathname === route || pathname.startsWith(route + "/")
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Box component="main" sx={{ flex: 1 }}>
        <Routes>
          {/* Registration Pages */}
          <Route path="/register" element={<Register />} />
          <Route path="/first-time-register" element={<FirstTimeRegister />} />
          <Route path="/create-enhancement-request" element={<EnhancementCenter />} />
          <Route
            path="/team-member-register/:token"
            element={<TeamMemberRegister />}
          />
          <Route
            path="/internal-user-register/:token"
            element={<InternalUserRegister />}
          />
          <Route
            path="/lawfirm-user-register/:token"
            element={<LawFirmUserRegister />}
          />
          <Route
            path="/professional-guardian-register/:token"
            element={<ProfessionalGuardianRegister />}
          />
          <Route
            path="/pg-contact-register/:token"
            element={<PgContactRegister />}
          />
          <Route
            path="/vermost-probate-bond-request-guest"
            element={<VermostProbateBondRequestForm />}
          />
          <Route
            path="/vermost-guardianship-bond-request-guest"
            element={<VermostGuardianshipBondRequestForm />}
          />
          <Route
            path="/vermost-trustee-bond-request-guest"
            element={<VermostTrusteeBondRequestForm />}
          />
          <Route
            path="/vermost-va-bond-request-guest"
            element={<VermostVABondRequestForm />}
          />
          <Route
            path="/vermost-blanket-bond-request-guest"
            element={<VermostBlanketBondRequestForm />}
          />

          {/* Shared Non-Auth Pages */}
          <Route path="/" element={<Login />} />
          <Route path="/guest-request" element={<GuestRequestSample />} />
          <Route path="/profile" element={<UserProfileUpdate />} />
          <Route
            path="/bond-creation-outsider"
            element={
              <AuthGuard>
                <VermostOutsiderStartBondRequest />
              </AuthGuard>
            }
          />
          <Route
            path="/bond-creation-outsider-historic"
            element={
              <AuthGuard>
                <VermostOutsiderStartBondRequestHistoric />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-blanket-bond-request"
            element={
              <AuthGuard>
                <VermostBlanketBondRequestForm />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-blanket-bond-request-cache/:cache_id"
            element={
              <AuthGuard>
                <VermostBlanketBondRequestForm />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-probate-bond-request"
            element={
              <AuthGuard>
                <VermostProbateBondRequestForm />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-probate-bond-request-cache/:cache_id"
            element={
              <AuthGuard>
                <VermostProbateBondRequestForm />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-guardianship-bond-request"
            element={
              <AuthGuard>
                <VermostGuardianshipBondRequestForm />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-guardianship-bond-request-cache/:cache_id"
            element={
              <AuthGuard>
                <VermostGuardianshipBondRequestForm />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-guardianship-bond-update/:bond_id"
            element={
              <AuthGuard>
                <VermostGuardianshipBondRetrieveForm />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-va-bond-request"
            element={
              <AuthGuard>
                <VermostVABondRequestForm />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-va-bond-request-cache/:cache_id"
            element={
              <AuthGuard>
                <VermostVABondRequestForm />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-va-bond-update/:bond_id"
            element={
              <AuthGuard>
                <VermostVABondRetrieveForm />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-trustee-bond-update/:bond_id"
            element={
              <AuthGuard>
                <VermostTrusteeBondRetrieveForm />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-probate-bond-historic"
            element={
              <AuthGuard>
                <ProbateBondCreateHistoric />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-guardianship-bond-historic"
            element={
              <AuthGuard>
                <GuardianshipBondCreateHistoric />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-trustee-bond-historic"
            element={
              <AuthGuard>
                <TrusteeBondCreateHistoric />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-blanket-bond-historic"
            element={
              <AuthGuard>
                <BlanketBondCreateHistoric />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-va-bond-historic"
            element={
              <AuthGuard>
                <VABondCreateHistoric />
              </AuthGuard>
            }
          />
          <Route
            path="/view-enhancement-requests"
            element={
              <AuthGuard>
                <ViewEnhancementRequests />
              </AuthGuard>
            }
          />
          <Route
            path="/analytics"
            element={
              <AuthGuard>
                <Analytics />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-blanket-bond-update/:bond_id"
            element={
              <AuthGuard>
                <VermostBlanketBondRetrieveForm />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-trustee-bond-request"
            element={
              <AuthGuard>
                <VermostTrusteeBondRequestForm />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-trustee-bond-request-cache/:cache_id"
            element={
              <AuthGuard>
                <VermostTrusteeBondRequestForm />
              </AuthGuard>
            }
          />

          <Route
            path="/vermost-probate-bond-update/:bond_id"
            element={
              <AuthGuard>
                <VermostProbateBondRetrieveForm />
              </AuthGuard>
            }
          />

          <Route
            path="/release-rider-probate/:bond_id"
            element={
              <AuthGuard>
                <ProbateRider />
              </AuthGuard>
            }
          />

          <Route
            path="/release-rider-guardianship/:bond_id"
            element={
              <AuthGuard>
                <GuardianshipRider />
              </AuthGuard>
            }
          />

          <Route
            path="/release-rider-trustee/:bond_id"
            element={
              <AuthGuard>
                <TrusteeRider />
              </AuthGuard>
            }
          />

          <Route
            path="/release-rider-va/:bond_id"
            element={
              <AuthGuard>
                <VABondRider />
              </AuthGuard>
            }
          />

          <Route
            path="/admin_account_management"
            element={
              <AuthGuard>
                <AdminAccountManagement />
              </AuthGuard>
            }
          />

          <Route
            path="/vermost_duplicate_accounts"
            element={
              <AuthGuard>
                <RequireSuperUser>
                  <DuplicateAccountsMergePage />
                </RequireSuperUser>
              </AuthGuard>
            }
          />

          <Route
            path="/admin_data_management"
            element={
              <AuthGuard>
                <AdminDataManagement />
              </AuthGuard>
            }
          />

          <Route
            path="/admin_system_management"
            element={
              <AuthGuard>
                <AdminSystemManagement />
              </AuthGuard>
            }
          />

          <Route
            path="/admin/support-requests"
            element={
              <AuthGuard>
                <SupportRequestsLog />
              </AuthGuard>
            }
          />

          <Route
            path="/admin_home"
            element={
              <AuthGuard>
                <AdminHome />
              </AuthGuard>
            }
          />
          <Route
            path="/internal_user_home"
            element={
              <AuthGuard>
                <SimpleUserHome />
              </AuthGuard>
            }
          />
          <Route
            path="/simple_user_account_management"
            element={
              <AuthGuard>
                <SimpleUserAccountManagement />
              </AuthGuard>
            }
          />
          <Route
            path="/simple_user_data_management"
            element={
              <AuthGuard>
                <SimpleUserDataManagement />
              </AuthGuard>
            }
          />
          <Route
            path="/simple_user_system_management"
            element={
              <AuthGuard>
                <SimpleUserSystemManagement />
              </AuthGuard>
            }
          />
          <Route
            path="/professional_guardian_home"
            element={
              <AuthGuard>
                <ProfessionalGuardianHome />
              </AuthGuard>
            }
          />
          <Route
            path="/professional_guardian_view_bonds/:id"
            element={
              <AuthGuard>
                <ProfessionalGuardianViewBonds />
              </AuthGuard>
            }
          />
          <Route
            path="/law_firm_user_home"
            element={
              <AuthGuard>
                <LawFirmUserHome />
              </AuthGuard>
            }
          />
          <Route
            path="/law_firm_admin_home"
            element={
              <AuthGuard>
                <LawFirmUserAdminHome />
              </AuthGuard>
            }
          />
          <Route
            path="/law-firm/access-requests"
            element={
              <AuthGuard>
                <LawFirmAccessRequests />
              </AuthGuard>
            }
          />
          <Route
            path="/pg_contact_home"
            element={
              <AuthGuard>
                <PgContactHome />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost-professional-guardian-list"
            element={
              <AuthGuard>
                <ProfessionalGuardianList />
              </AuthGuard>
            }
          />
          <Route
            path="/view_professional_guardian/:pg_id"
            element={
              <AuthGuard>
                <ProfessionalGuardianView />
              </AuthGuard>
            }
          />
          <Route
            path="/create_professional_guardian"
            element={
              <AuthGuard>
                <CreateProfessionalGuardian />
              </AuthGuard>
            }
          />
          <Route
            path="/guardian-limits/:pg_id"
            element={
              <AuthGuard>
                <ProfessionalGuardianLimits />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost_carrier_list"
            element={
              <AuthGuard>
                <CarrierList />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost_lawfirm_list"
            element={
              <AuthGuard>
                <LawFirmList />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost_carrier_profile/:id"
            element={
              <AuthGuard>
                <CarrierProfile />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost_premiums_manager"
            element={
              <AuthGuard>
                <PremiumManager />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost_internal_users"
            element={
              <AuthGuard>
                <UserList />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost_law_firm_users"
            element={
              <AuthGuard>
                <LawFirmUserList />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost_approve_bonds"
            element={
              <AuthGuard>
                <ApproveBondsPage />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost_bond_archives"
            element={
              <AuthGuard>
                <BondArchives />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost_manually_signed_indemnities"
            element={
              <AuthGuard>
                <ManuallySignedIndemnities />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost_approve_bonds_lawfirm"
            element={
              <AuthGuard>
                <LawfirmApproveBondsPage />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost_cancel_bonds_lawfirm"
            element={
              <AuthGuard>
                <LawfirmCancelBondsPage />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost_endorse_bonds_lawfirm"
            element={
              <AuthGuard>
                <LawfirmEndorseBondsPage />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost_view_probate_underwriting"
            element={
              <AuthGuard>
                <VermostProbateBondRetrieveForm />
              </AuthGuard>
            }
          />
          <Route
            path="/carrier_team_member_dashboard"
            element={
              <AuthGuard>
                <CarrierTeamMemberDashboard />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost_approve_bonds_teammember"
            element={
              <AuthGuard>
                <ApproveBondsTeamMemberPage />
              </AuthGuard>
            }
          />

          <Route
            path="/premium_calculator"
            element={
              <AuthGuard>
                <PremiumCalculator />
              </AuthGuard>
            }
          />
          <Route
            path="/new_internal_user"
            element={
              <AuthGuard>
                <CreateInternalUser />
              </AuthGuard>
            }
          />
          <Route
            path="/edit_internal_user/:internal_user_id"
            element={
              <AuthGuard>
                <EditInternalUser />
              </AuthGuard>
            }
          />
          <Route
            path="/bond_numbers"
            element={
              <AuthGuard>
                <BondNumberTable />
              </AuthGuard>
            }
          />
          <Route
            path="/law_schools"
            element={
              <AuthGuard>
                <LawSchoolList />
              </AuthGuard>
            }
          />
          <Route
            path="/states"
            element={
              <AuthGuard>
                <StateList />
              </AuthGuard>
            }
          />
          <Route
            path="/bondtypes"
            element={
              <AuthGuard>
                <BondTypeList />
              </AuthGuard>
            }
          />
          <Route
            path="/announcements"
            element={
              <AuthGuard>
                <Announcement />
              </AuthGuard>
            }
          />
          <Route
            path="/state-details/:stateId"
            element={
              <AuthGuard>
                <StateDetails />
              </AuthGuard>
            }
          />
          <Route
            path="/add_law_firm"
            element={
              <AuthGuard>
                <CreateLawFirm />
              </AuthGuard>
            }
          />
          <Route
            path="/add_location/:id"
            element={
              <AuthGuard>
                <CreateLocations />
              </AuthGuard>
            }
          />
          <Route
            path="/lawfirmdetails/:id"
            element={
              <AuthGuard>
                <LawFirmDetail />
              </AuthGuard>
            }
          />
          <Route
            path="/lawfirmlocationdetails/:id"
            element={
              <AuthGuard>
                <LawFirmLocationDetail />
              </AuthGuard>
            }
          />
          <Route
            path="/addlawfirmuser/:id"
            element={
              <AuthGuard>
                <LegalServiceProfessionalForm />
              </AuthGuard>
            }
          />
          <Route
            path="/editlawfirmuser/:id/:location_id"
            element={
              <AuthGuard>
                <EditProfessionalDetailsForm />
              </AuthGuard>
            }
          />
          <Route
            path="/lawfirm-user-limits/:lawfirm_user_id"
            element={
              <AuthGuard>
                <LawFirmUserLimits />
              </AuthGuard>
            }
          />
          <Route
            path="/obligees"
            element={
              <AuthGuard>
                <ObligeeList />
              </AuthGuard>
            }
          />

          {/* Paralegal Routes */}
          <Route
            path="/vermost_paralegals_list"
            element={
              <AuthGuard>
                <ParalegalList />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost_create_paralegal"
            element={
              <AuthGuard>
                <NewParalegal />
              </AuthGuard>
            }
          />
          <Route
            path="/vermost_paralegal_detail/:id"
            element={
              <AuthGuard>
                <ParalegalDetail />
              </AuthGuard>
            }
          />
          <Route
            path="/my-enhancement-requests"
            element={<EnhancementCenter />}
          />
        </Routes>
      </Box>
      {shouldShowFooter && <Footer />}
      <ToastContainer />
    </Box>
  );
}

export default App;
